import React, { HTMLAttributes } from 'react';
import Typography from '../../typography/presentational/Typography';

interface BulletPointProps extends HTMLAttributes<HTMLDivElement> {
    className?: string;
    small?: boolean;
    leftText?: string;
    rightText?: React.ReactNode;
    html?: boolean;
    dash?: boolean;
}

const BulletPoint = ({
    className,
    small,
    leftText,
    rightText,
    html,
    dash,
    ...props
}: BulletPointProps) => {
    const classes: string[] = [];
    if (small) classes.push('small');
    if (className) classes.push(className);

    return (
        <div {...props} className={`sm-bullet-point ${classes.join(' ')}`}>
            <div className="left">
                <span className={`bullet-point ${dash ? 'dash' : ''}`} />
                {html ? (
                    <Typography
                        dangerouslySetInnerHTML={{ __html: leftText ?? '' }}
                    />
                ) : (
                    <Typography>{leftText}</Typography>
                )}
            </div>
            <span className="right">
                <Typography>{rightText}</Typography>
            </span>
        </div>
    );
};

export default BulletPoint;
